import { s } from '@/theme/tokens';
import { Box } from '@/ui';
import type { ReactElement, ReactNode } from 'react';

type SettingsPanelActionRowProps = {
  children: ReactNode;
};

export const SettingsPanelActionRow = ({ children }: SettingsPanelActionRowProps): ReactElement => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: s('md'),
      mt: s('sm'),
      width: '100%',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: s('sm') }}>{children}</Box>
  </Box>
);
